import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { LicenseService } from "src/app/core/services/license.service";
import { CloseNotifComponent } from "../close-notif/close-notif.component";
import axios from "axios";
import moment from "moment";

@Component({
  selector: "app-add-license",
  templateUrl: "./add-license.component.html",
  styleUrls: ["./add-license.component.scss"],
})
export class AddLicenseComponent implements OnInit {

  showTagalog: boolean = false;
  language = "Translate to Tagalog";
  buttonColor = 'accent';
  textClass = 'text-black'

  userData: any;

  licenseFormGroup: FormGroup;

  selectedLicenseType: any;

  isLicenseBeingAdded: boolean = false;
  isLicenseDisabled: boolean = false;

  successMessage: boolean = false;
  errorMessage: boolean = false;

  formattedMaxDate: string;

  years: number[] = [];
  currentYear: number;
  currentMonth: number;
  minDate: Date;
  maxDate: Date;

  licenseTypes = [
    { id: 0, name: "Civil Service Commission  (CSC)" },
    { id: 1, name: "Professional Regulation Commission (PRC)" },
  ];

  civilServiceLevels = [
    { id: 0, name: "Career Executive Officer Eligibility" },
    { id: 1, name: "Career Executive Service Officer" },
    { id: 2, name: "Career Service Executive Eligibility" },
    { id: 3, name: "Career Service Professional" },
    { id: 4, name: "Career Service Sub Professional" },
    { id: 5, name: "Data Encoder" },
    { id: 6, name: "Fire Officer 2" },
    { id: 7, name: "Forestry Extension Service" },
    { id: 8, name: "Police Officer 1" },
    { id: 9, name: "R.A 1080" },
    { id: 10, name: "Soil Technologist" },
    { id: 11, name: "Stenographer" },
  ];

  months = [
    { value: 1, viewValue: "January" },
    { value: 2, viewValue: "February" },
    { value: 3, viewValue: "March" },
    { value: 4, viewValue: "April" },
    { value: 5, viewValue: "May" },
    { value: 6, viewValue: "June" },
    { value: 7, viewValue: "July" },
    { value: 8, viewValue: "August" },
    { value: 9, viewValue: "September" },
    { value: 10, viewValue: "October" },
    { value: 11, viewValue: "November" },
    { value: 12, viewValue: "December" },
  ];

  filteredMonths = [];

  constructor(
    private fb: FormBuilder,
    private licenseService: LicenseService,
    private dialog: MatDialog
  ) {

    const currentDatetime = moment(); // Get current date and time
    this.minDate = currentDatetime.toDate();
    this.maxDate = currentDatetime.toDate();

    this.currentYear = currentDatetime.year();
    this.currentMonth = currentDatetime.month() + 1; // month() returns 0-based index, so add 1 for 1-based indexing
    const minYear = 1800;
    const yearsToDisplay = this.currentYear - minYear;

    this.populateYears(this.currentYear, yearsToDisplay);
    this.updateFilteredMonths(this.currentYear);
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("applicantDetails"));

    this.licenseFormGroup = this.fb.group({
      licenseType: ["", Validators.required],
      eligibilityLevel: [""],
      prc: [""],
      takenDateMonth: [""],
      takenDateYear: [""],
      validUntilDate: [""],
    });

    this.licenseFormGroup.get('takenDateYear')?.valueChanges.subscribe(selectedYear => {
      this.updateFilteredMonths(selectedYear);
    });
  }

  addLicense() {
    if (this.licenseFormGroup.invalid) {
      this.errorMessage = true

      setTimeout(() => {
        this.errorMessage = false;
      }, 3000);

    } else {

      this.isLicenseBeingAdded = true;
      this.isLicenseDisabled = true

      const takenDateMonth = this.licenseFormGroup.controls.takenDateMonth.value;
      const takenDateYear = this.licenseFormGroup.controls.takenDateYear.value;
      const takenDateMonthYear = takenDateMonth + takenDateYear;
      const validUntilDateValue = this.licenseFormGroup.controls.validUntilDate
        .value
        ? this.licenseFormGroup.controls.validUntilDate.value
        : this.licenseFormGroup.controls.validUntilDate.setValue(null);
      const validUntilDateISO = validUntilDateValue
        ? new Date(
          validUntilDateValue.getTime() -
          validUntilDateValue.getTimezoneOffset() * 60000
        ).toISOString()
        : null;

      const licenseData = {
        applicantId: this.userData.id,
        licenseType: this.licenseFormGroup.controls?.licenseType.value || "",
        eligibilityLevel:
          this.licenseFormGroup.controls?.eligibilityLevel.value || "",
        prc: this.licenseFormGroup.controls?.prc.value || "",
        takenDate: takenDateMonthYear,
        validUntilDate: validUntilDateISO,
      };

      const licenseType = licenseData.licenseType;

      if (licenseType == "Professional Regulation Commission (PRC)") {
        licenseData.takenDate = "";
      }

      if (licenseType == "Civil Service Commission  (CSC)") {
        licenseData.validUntilDate = "";
      }

      this.licenseService.addLicense(licenseData).subscribe((response) => {

        this.isLicenseBeingAdded = false;
        this.isLicenseDisabled = false;

        this.successMessage = true;

        setTimeout(() => {
          this.dialog.closeAll();
        }, 3000);
      });
    }
  }

  currentLicenseType() {
    const licensetype = this.selectedLicenseType;

    if (licensetype === "Civil Service Commission  (CSC)") {
      this.licenseFormGroup
        .get("eligibilityLevel")
        .setValidators(Validators.required);
      this.licenseFormGroup
        .get("takenDateMonth")
        .setValidators(Validators.required);
      this.licenseFormGroup
        .get("takenDateYear")
        .setValidators(Validators.required);

      // Update the form control status after setting validators
      this.licenseFormGroup.get("eligibilityLevel").updateValueAndValidity();
      this.licenseFormGroup.get("takenDateMonth").updateValueAndValidity();
      this.licenseFormGroup.get("takenDateYear").updateValueAndValidity();

      this.licenseFormGroup.get("prc").clearValidators();
      this.licenseFormGroup.get("validUntilDate").clearValidators();

      // Update the form control status after clearing validators
      this.licenseFormGroup.get("prc").updateValueAndValidity();
      this.licenseFormGroup.get("validUntilDate").updateValueAndValidity();
    } else {
      this.licenseFormGroup
        .get("prc")
        .setValidators([Validators.required, this.notEmptyString]);
      this.licenseFormGroup
        .get("validUntilDate")
        .setValidators(Validators.required);

      // Update the form control status after setting validators
      this.licenseFormGroup.get("prc").updateValueAndValidity();
      this.licenseFormGroup.get("validUntilDate").updateValueAndValidity();

      this.licenseFormGroup.get("eligibilityLevel").clearValidators();
      this.licenseFormGroup.get("takenDateMonth").clearValidators();
      this.licenseFormGroup.get("takenDateYear").clearValidators();

      // Update the form control status after clearing validators
      this.licenseFormGroup.get("eligibilityLevel").updateValueAndValidity();
      this.licenseFormGroup.get("takenDateMonth").updateValueAndValidity();
      this.licenseFormGroup.get("takenDateYear").updateValueAndValidity();
    }
  }

  closeNotif() {
    this.dialog.open(CloseNotifComponent);
  }

  formatDate(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  notEmptyString(control) {
    const value = control.value;

    if (value === null || value.trim() === "") {
      return { notEmptyString: true };
    }

    return null;
  }

  toggleTagalogTranslation() {

    this.showTagalog = !this.showTagalog;
    this.language =
      this.language === "Translate to Tagalog"
        ? "Translate to English"
        : "Translate to Tagalog";

    this.buttonColor =
      this.language === "Translate to Tagalog" ? "accent" : "primary";
    this.textClass = this.language == "Translate to Tagalog" ? "text-black" : "text-white";

    this.licenseTypes.forEach(type => {

      if (type.id === 0) {
        type.name = type.name === 'Civil Service Commission  (CSC)' ? 'Komisyon ng Serbisyo Sibil' : 'Civil Service Commission  (CSC)'
      }

      if (type.id == 1) {
        type.name = type.name === 'Professional Regulation Commission (PRC)' ? 'Komisyon ng Regulasyon ng Propesyonal' : 'Professional Regulation Commission (PRC)'
      }

    });

    const englishMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const tagalogMonths = ["Enero", "Pebrero", "Marso", "Abril", "Mayo", "Hunyo", "Hulyo", "Agosto", "Setyembre", "Oktubre", "Nobyembre", "Disyembre"];

    this.months.forEach((month, index) => {
      month.viewValue = this.showTagalog ? tagalogMonths[index] : englishMonths[index];
    });

  }

  populateYears(currentYear: number, yearsToGoBack: number): void {
    this.years = [];
    for (let i = 0; i <= yearsToGoBack; i++) {
      this.years.push(currentYear - i);
    }
  }

  updateFilteredMonths(selectedYear: number): void {
    if (selectedYear === this.currentYear) {
      this.filteredMonths = this.months.filter(month => month.value <= this.currentMonth);
    } else {
      this.filteredMonths = this.months;
    }
  }
}
